import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react"; // Use QRCodeCanvas instead of QRCodeSVG
import Header from "./Header";
import Footer from "./Footer";

const QRCodeGenerator = () => {
  const [qrType, setQrType] = useState("url");
  const [qrInput, setQrInput] = useState("");
  const [qrData, setQrData] = useState("");

  const generateQRCode = () => {
    if (!qrInput.trim()) {
      alert("Please enter valid information to generate the QR code.");
      return;
    }

    let formattedData;
    switch (qrType) {
      case "url":
        formattedData = qrInput;
        break;
      case "whatsapp":
        formattedData = `https://wa.me/${qrInput}`;
        break;
      case "text":
        formattedData = qrInput;
        break;
      case "email":
        formattedData = `mailto:${qrInput}`;
        break;
      default:
        formattedData = qrInput;
    }
    setQrData(formattedData);
  };

  const downloadQRCode = () => {
    const canvas = document.querySelector("canvas"); // Select the canvas element
    if (!canvas) {
      console.error("Canvas element not found");
      return;
    }
    const url = canvas.toDataURL("image/png"); // Convert canvas to data URL
    const a = document.createElement("a");
    a.href = url;
    a.download = "qrcode.png";
    a.click();
  };

  return (
    <>
      <Header />
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Row>
          <Col
            md={12}
            className="text-center p-4"
            style={{
              background: "white",
              borderRadius: "10px",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h1>QR Code Generator</h1>
            <p className="mt-4">QR codes are incredibly versatile tools that can enhance how you share information. Whether you need to link to a URL, encode text, share an email address, or even connect through WhatsApp, a QR code can simplify the process. If you're looking for a hassle-free way to generate these codes, consider using a free QR code generator on Google. These tools provide a free QR code generator with no sign-up required, making it easy to create and use QR codes instantly. Simply enter your desired content, and you'll have a scannable code ready to go, streamlining the way you connect and share information.</p>
            <Form>
              <Form.Group>
                <Form.Label>Select QR Code Type:</Form.Label>
                <Form.Control as="select" value={qrType} onChange={(e) => setQrType(e.target.value)}>
                  <option value="url">URL</option>
                  <option value="whatsapp">WhatsApp</option>
                  <option value="text">Text</option>
                  <option value="email">Email</option>
                </Form.Control>
              </Form.Group>
              <Form.Group className="mt-3">
                <Form.Label>Enter your information:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter URL, text, or email"
                  value={qrInput}
                  onChange={(e) => setQrInput(e.target.value)}
                />
              </Form.Group>
              <Button variant="primary" className="mt-3" onClick={generateQRCode}>
                Generate QR Code
              </Button>
            </Form>
            {qrData && (
              <div className="mt-4">
                <QRCodeCanvas value={qrData} size={200} /> {/* Use QRCodeCanvas */}
                <br />
                <Button variant="success" className="mt-3" onClick={downloadQRCode}>
                  Download QR Code
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

export default QRCodeGenerator;
